import { css } from '@emotion/react';

import { typography2 as typography } from '@coursera/cds-core';

import generateEmotionClasses from 'bundles/unified-common/components/pill/generateEmotionClasses';

export const buttonBaseClasses = generateEmotionClasses('buttonBase', ['focusVisible']);

export const classes = generateEmotionClasses('Pill', ['root']);

// NOTE: there is no CDS border radius for 100px
const borderRadius = '100px';

const getPillCss = css`
  &.${classes.root} {
    ${typography.bodySecondary};
    color: var(--cds-color-neutral-primary);
    text-align: center;
    display: inline-flex;
    align-items: center;
    gap: var(--cds-spacing-50);
    padding: var(--cds-spacing-100) var(--cds-spacing-150);
    border-radius: ${borderRadius};
    border: 1px solid var(--cds-color-emphasis-primary-background-xweak);
    background-color: var(--cds-color-emphasis-primary-background-xweak);

    &:hover {
      color: var(--cds-color-blue-800);
      border: 1px solid var(--cds-color-blue-800);
      background: var(--cds-color-blue-25);
    }

    &:focus {
      color: var(--cds-color-neutral-primary);
      border: 1px solid var(--cds-color-purple-800);
      background: var(--cds-color-emphasis-primary-background-xweak);
    }

    &:active {
      color: var(--cds-color-purple-900);
      border: 1px solid var(--cds-color-purple-900);
      background: var(--cds-color-purple-25);
    }

    &.${buttonBaseClasses.focusVisible}::after {
      border-radius: ${borderRadius};
      inset: 0;
    }
  }
`;

export default getPillCss;
